var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-card-documents-list',{attrs:{"folder-params":_vm.folderParams,"visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }